// extracted by mini-css-extract-plugin
module.exports = {"body":"home_body__215hG","logo":"home_logo__2JCID","payButton":"home_payButton__22vn9","link":"home_link__1FM2f","row":"home_row__2GJkL","column":"home_column__2AJK0"};